<template>
  <div class="rs-listing__parsha">
    <div class="rs-listing__parsha__level1">
      <div class="rs-listing__parsha__selector">
        <button
          class="rs-listing__parsha__selector__button"
          @click="toggleModal"
        >
          <span
            v-html="
              selectedParsha
                ? getParshaObjectFromSlug(selectedParsha).name
                : 'Select Parsha'
            "
          ></span>
          <svg
            width="12.908"
            height="9.828"
            viewBox="0 0 12.908 9.828"
            :class="isModalOpen && 'rs-listing__rotate180'"
          >
            <path
              d="M8.848-3.836l-6.832-6.44,6.832-6.468h3l-6.86,6.468,6.86,6.44Z"
              transform="translate(16.744 11.844) rotate(-90)"
              fill="#652981"
            />
          </svg>
        </button>
        <div class="rs-listing__parsha__selector__modal" v-if="isModalOpen">
          <div
            v-if="!selectedBookParshot"
            class="rs-listing__parsha__selector__modal__level0"
          >
            <button
              class="rs-listing__parsha__selector__modal__buttonall"
              :class="
                !selectedParsha &&
                'rs-listing__parsha__selector__modal__selected'
              "
              @click="showAll"
            >
              All
            </button>
            <button
              v-for="book in books"
              :key="book.term_id"
              :class="
                getBookFromParsha(selectedParsha) === book &&
                'rs-listing__parsha__selector__modal__selected'
              "
              @click="selectedBookParshot = book.parshot"
            >
              <span v-html="book.name"></span>
              <svg width="5.616" height="7.376" viewBox="0 0 5.616 7.376">
                <path
                  d="M1.216-2.192l3.92-3.68-3.92-3.7H2.928l3.9,3.7-3.9,3.68Z"
                  transform="translate(-1.216 9.568)"
                  fill="#652981"
                />
              </svg>
            </button>
          </div>
          <div
            v-if="selectedBookParshot"
            class="rs-listing__parsha__selector__modal__level1"
          >
            <button
              class="rs-listing__parsha__selector__modal__buttonback"
              @click="selectedBookParshot = null"
            >
              &lt; Back
            </button>
            <span
              v-html="getBookFromParsha(selectedBookParshot[0].slug).name"
              class="rs-listing__parsha__selector__modal__title"
            ></span>
            <button
              v-for="parsha in selectedBookParshot"
              :key="parsha.slug"
              :class="
                selectedParsha === parsha.slug &&
                'rs-listing__parsha__selector__modal__selected'
              "
              @click="selectParsha(parsha)"
            >
              {{ parsha.name }}
            </button>
          </div>
        </div>
      </div>
      <div class="rs-listing__parsha__link-to-fe__desktop">
        <a href="/covenant-conversation/"
          >View the main Covenant &amp; Conversation essays &gt;</a
        >
      </div>
    </div>
    <div class="rs-listing__parsha__level2">
      <div class="rs-listing__parsha__description">
        <p v-if="selectedParsha" v-html="getParshaObjectFromSlug(selectedParsha).description"></p>
        <p v-else>
          Explore Rabbi Sacks&apos; wisdom, insights, and teachings on the Torah (the Hebrew Bible).
          <!-- “I have called these studies Covenant and Conversation because this,
          for me, is the essence of what Torah learning is – throughout the
          ages, and for us, now. The text of Torah is our covenant with God, our
          written constitution as a nation under His sovereignty. The
          interpretation of this text has been the subject of an ongoing
          conversation for as long as Jews have studied the divine word, a
          conversation that began at Sinai thirty-three centuries ago and has
          not ceased since. Every age has added its commentaries, and so must
          ours. Participating in that conversation is a major part of what it is
          to be a Jew. For we are the people who never stopped learning the Book
          of Life, our most precious gift from the God of life.” &mdash; Rabbi
          Sacks -->
        </p>
      </div>
      <div
        class="rs-listing__parsha__image"
        v-html="
          selectedParsha
            ? getParshaObjectFromSlug(selectedParsha).featured_image
            : '&nbsp;'
        "
      ></div>
    </div>
    <div class="rs-listing__parsha__link-to-fe__mobile">
      <a href="/covenant-conversation/">Main Essays &gt;</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fetchedParshot: Array,
    selectedParsha: String,
  },
  data: function () {
    return {
      isModalOpen: false,
      selectedBookParshot: null,
      books: [],
    };
  },
  mounted() {
    this.processFetchedParshot();
  },
  watch: {
    fetchedParshot() {
      this.processFetchedParshot();
    },
  },
  methods: {
    processFetchedParshot() {
      let parshotByBook = {};
      this.fetchedParshot.forEach((parsha) => {
        if (parsha.parent == 0) {
          this.books.push(parsha);
        } else {
          if (!parshotByBook[parsha.parent]) {
            parshotByBook[parsha.parent] = [];
          }
          parshotByBook[parsha.parent].push(parsha);
        }
      });
      this.books.forEach((book) => {
        book.parshot = parshotByBook[book.term_id];
        book.parshot.sort((a, b) => a.sorting_order - b.sorting_order);
      });
      this.books.sort((a, b) => a.sorting_order - b.sorting_order);
    },
    showAll() {
      this.selectedBookParshot = null;
      this.$emit("selected-parsha-change", null);
      this.toggleModal();
    },
    selectParsha(parsha) {
      this.$emit("selected-parsha-change", parsha ? parsha.slug : null);
      this.toggleModal();
    },
    toggleModal() {
      if (this.isModalOpen) {
        this.isModalOpen = false;
      } else {
        this.selectedBookParshot = this.getBookFromParsha(
          this.selectedParsha
        )?.parshot;
        this.isModalOpen = true;
      }
    },
    getBookFromParsha(parshaSlug) {
      let _book = null;
      this.books.forEach((book) => {
        book.parshot.forEach((loopParshaObj) => {
          if (loopParshaObj.slug === parshaSlug) {
            _book = book;
          }
        });
      });
      return _book;
    },
    getParshaObjectFromSlug(parshaSlug) {
      let _parshaObj = null;
      this.books.forEach((book) => {
        book.parshot.forEach((loopParshaObj) => {
          if (loopParshaObj.slug === parshaSlug) {
            _parshaObj = loopParshaObj;
            return;
          }
        });
      });
      return _parshaObj;
    },
  },
};
</script>
